import { Component, signal, inject } from '@angular/core';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { EmployeeFormComponent } from '../../active-employees/form/employee-form.component';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeService } from '../../../../../_services/employee-service/employee.service';
import { OffcanvasHeaderBtnComponent } from '../../../../../shared/components/offcanvas/offcanvas-header-btn/offcanvas-header-btn.component';
import { OffcanvasBaseComponent } from '../../../../../shared/components/offcanvas/offcanvas-base/offcanvas-base.component';

@Component({
  selector: 'app-employee-details',
  imports: [TabsModule, EmployeeFormComponent, OffcanvasHeaderBtnComponent, OffcanvasBaseComponent],
  templateUrl: './add-employee-details.component.html',
  providers: [NgbActiveOffcanvas],
})
export class AddEmployeeDetailsComponent {
  readonly employeeService = inject(EmployeeService);

  protected returnUrl = signal(this.employeeService.conditionalReturnUrl());
}
